import { Socket } from "phoenix"

// Phoenix hands a socket the cookie session through `connect_info` only when
// the handshake also carries the page's CSRF token: see
// `Phoenix.Socket.Transport.connect_session/4`, which returns nil unless
// `params["_csrf_token"]` validates against the state stored in the session.
// `/user_socket` requests `connect_info: [session: ...]` in `EnaiaWeb.Endpoint`
// and `EnaiaWeb.UserSocket` verifies the trusted-mobile bindings against it, so
// without this parameter every trusted-mobile presence connection is refused.
// The LiveView socket in `app.js` already sends it from the same meta tag.
function csrfToken() {
  const meta = document.querySelector("meta[name='csrf-token']")
  return meta && meta.getAttribute("content")
}

function createSocket() {
  let socket = new Socket("/user_socket", {
    params: {
      encoded_user_token: window.encodedUserToken,
      _csrf_token: csrfToken(),
    },
  })

  socket.connect()
  return socket
}

let socket = null
if (window.encodedUserToken) socket = createSocket()
else console.log("No user token found. This is normal within a storybook")

export default socket
